const translations = {
  // === SIDEBAR / NAV ===
  dashboard: { fr: 'Tableau de Bord', ar: 'لوحة القيادة' },
  clients: { fr: 'Clients', ar: 'العملاء' },
  fournisseurs: { fr: 'Fournisseurs', ar: 'الموردون' },
  ventes: { fr: 'Ventes', ar: 'المبيعات' },
  devis: { fr: 'Devis', ar: 'عروض الأسعار' },
  paiements: { fr: 'Paiements', ar: 'المدفوعات' },
  remboursements: { fr: 'Remboursements', ar: 'المبالغ المستردة' },
  avoirs: { fr: 'Avoirs', ar: 'الأرصدة الدائنة' },
  rapports: { fr: 'Rapports', ar: 'التقارير' },
  emails: { fr: 'Emails', ar: 'البريد الإلكتروني' },
  chat: { fr: 'Chat', ar: 'المحادثة' },
  agents: { fr: 'Agents', ar: 'الوكلاء' },
  parametres: { fr: 'Parametres', ar: 'الإعدادات' },
  voyages: { fr: 'Voyages', ar: 'الرحلات' },
  billetterie: { fr: 'Billetterie', ar: 'التذاكر' },
  produits: { fr: 'Produits', ar: 'المنتجات' },
  paie_fournisseurs: { fr: 'Paie. Fournisseurs', ar: 'دفع الموردين' },
  bons_commande: { fr: 'Bons de Commande', ar: 'أوامر الشراء' },
  deconnexion: { fr: 'Deconnexion', ar: 'تسجيل الخروج' },
  changer_mdp: { fr: 'Changer mot de passe', ar: 'تغيير كلمة المرور' },

  // === COMMON ===
  rechercher: { fr: 'Rechercher', ar: 'بحث' },
  ajouter: { fr: 'Ajouter', ar: 'إضافة' },
  modifier: { fr: 'Modifier', ar: 'تعديل' },
  supprimer: { fr: 'Supprimer', ar: 'حذف' },
  enregistrer: { fr: 'Enregistrer', ar: 'حفظ' },
  annuler: { fr: 'Annuler', ar: 'إلغاء' },
  confirmer: { fr: 'Confirmer', ar: 'تأكيد' },
  fermer: { fr: 'Fermer', ar: 'إغلاق' },
  suivant: { fr: 'Suivant', ar: 'التالي' },
  precedent: { fr: 'Precedent', ar: 'السابق' },
  page: { fr: 'Page', ar: 'صفحة' },
  total: { fr: 'Total', ar: 'المجموع' },
  date: { fr: 'Date', ar: 'التاريخ' },
  statut: { fr: 'Statut', ar: 'الحالة' },
  actions: { fr: 'Actions', ar: 'الإجراءات' },
  nom: { fr: 'Nom', ar: 'الاسم' },
  telephone: { fr: 'Telephone', ar: 'الهاتف' },
  email: { fr: 'Email', ar: 'البريد الإلكتروني' },
  adresse: { fr: 'Adresse', ar: 'العنوان' },
  type: { fr: 'Type', ar: 'النوع' },
  montant: { fr: 'Montant', ar: 'المبلغ' },
  oui: { fr: 'Oui', ar: 'نعم' },
  non: { fr: 'Non', ar: 'لا' },
  chargement: { fr: 'Chargement...', ar: 'جاري التحميل...' },
  aucun_resultat: { fr: 'Aucun resultat', ar: 'لا توجد نتائج' },
  erreur: { fr: 'Erreur', ar: 'خطأ' },
  succes: { fr: 'Succes', ar: 'نجاح' },
  obligatoire: { fr: 'Obligatoire', ar: 'إلزامي' },
  details: { fr: 'Details', ar: 'التفاصيل' },
  notes: { fr: 'Notes', ar: 'ملاحظات' },
  pays: { fr: 'Pays', ar: 'البلد' },
  ville: { fr: 'Ville', ar: 'المدينة' },
  description: { fr: 'Description', ar: 'الوصف' },

  // === CLIENTS ===
  nouveau_client: { fr: 'Nouveau Client', ar: 'عميل جديد' },
  modifier_client: { fr: 'Modifier Client', ar: 'تعديل العميل' },
  particulier: { fr: 'Particulier', ar: 'فرد' },
  entreprise: { fr: 'Entreprise', ar: 'شركة' },
  atv: { fr: 'ATV (Agence de voyage)', ar: 'وكالة سياحية' },
  fonction: { fr: 'Fonction', ar: 'الوظيفة' },
  reseaux_sociaux: { fr: 'Reseaux sociaux', ar: 'وسائل التواصل' },

  // === VENTES ===
  nouvelle_vente: { fr: 'Nouvelle Vente', ar: 'بيع جديد' },
  numero_vente: { fr: 'N Vente', ar: 'رقم البيع' },
  client: { fr: 'Client', ar: 'العميل' },
  agent: { fr: 'Agent', ar: 'الوكيل' },
  prix_vente: { fr: 'Prix Vente', ar: 'سعر البيع' },
  prix_achat: { fr: 'Prix Achat', ar: 'سعر الشراء' },
  remise: { fr: 'Remise', ar: 'الخصم' },
  commission: { fr: 'Commission', ar: 'العمولة' },
  montant_total: { fr: 'Montant Total', ar: 'المبلغ الإجمالي' },
  montant_paye: { fr: 'Montant Paye', ar: 'المبلغ المدفوع' },
  montant_restant: { fr: 'Reste a Payer', ar: 'المبلغ المتبقي' },
  montant_rembourse: { fr: 'Montant Rembourse', ar: 'المبلغ المسترد' },
  en_cours: { fr: 'En Cours', ar: 'قيد التنفيذ' },
  complete: { fr: 'Complete', ar: 'مكتمل' },
  annulee: { fr: 'Annulee', ar: 'ملغى' },
  paiement_initial: { fr: 'Paiement Initial', ar: 'الدفعة الأولى' },
  methode_paiement: { fr: 'Methode de Paiement', ar: 'طريقة الدفع' },
  especes: { fr: 'Especes', ar: 'نقدا' },
  cheque: { fr: 'Cheque', ar: 'شيك' },
  virement: { fr: 'Virement', ar: 'تحويل بنكي' },
  panier: { fr: 'Panier', ar: 'السلة' },
  article: { fr: 'article', ar: 'منتج' },
  articles: { fr: 'articles', ar: 'منتجات' },
  fournisseur: { fr: 'Fournisseur', ar: 'المورد' },
  designation: { fr: 'Designation', ar: 'التسمية' },
  numero_billet: { fr: 'N Billet', ar: 'رقم التذكرة' },
  code_compagnie: { fr: 'Code Compagnie', ar: 'رمز الشركة' },
  remboursable: { fr: 'Remboursable', ar: 'قابل للاسترداد' },
  non_remboursable: { fr: 'Non Remboursable', ar: 'غير قابل للاسترداد' },
  partiellement: { fr: 'Partiellement', ar: 'جزئيا' },

  // === PRODUCT TYPES ===
  billet_avion: { fr: 'Billet Avion', ar: 'تذكرة طيران' },
  billet_bateau: { fr: 'Billet Bateau', ar: 'تذكرة باخرة' },
  visa_rdv: { fr: 'Visa et RDV', ar: 'تأشيرة وموعد' },
  hotel_national: { fr: 'Hotel National', ar: 'فندق وطني' },
  hotel_international: { fr: 'Hotel International', ar: 'فندق دولي' },
  assurance_voyage: { fr: 'Assurance de Voyage', ar: 'تأمين السفر' },
  excursion: { fr: 'Excursion', ar: 'رحلة' },
  evenement: { fr: 'Evenement', ar: 'حدث' },
  location_bus: { fr: 'Location Bus', ar: 'تأجير حافلة' },
  location_guide: { fr: 'Location Guide', ar: 'دليل سياحي' },
  reservation_hotel_visa: { fr: 'Reservation Hotel Visa', ar: 'حجز فندق للتأشيرة' },
  autre: { fr: 'Autre', ar: 'أخرى' },
  voyage_organise: { fr: 'Voyage Organise', ar: 'رحلة منظمة' },

  // === DEVIS ===
  nouveau_devis: { fr: 'Nouveau Devis', ar: 'عرض سعر جديد' },
  modifier_devis: { fr: 'Modifier Devis', ar: 'تعديل عرض السعر' },
  transformer_en_vente: { fr: 'Transformer en Vente', ar: 'تحويل إلى بيع' },
  validite: { fr: 'Validite', ar: 'الصلاحية' },
  jours: { fr: 'jours', ar: 'أيام' },
  jours_restants: { fr: 'jours restants', ar: 'أيام متبقية' },
  expire: { fr: 'Expire', ar: 'منتهي' },
  total_ht: { fr: 'Total HT', ar: 'المجموع بدون ضريبة' },
  rappel: { fr: 'Rappel', ar: 'تذكير' },
  creer_rappel: { fr: 'Creer le rappel', ar: 'إنشاء تذكير' },
  frequence: { fr: 'Frequence', ar: 'التكرار' },
  details_pdf: { fr: 'Details (affiches dans le PDF)', ar: 'التفاصيل (تظهر في ملف PDF)' },

  // === PAIEMENTS ===
  nouveau_paiement: { fr: 'Nouveau Paiement', ar: 'دفعة جديدة' },
  paiement_par_produit: { fr: 'Paiement par produit', ar: 'الدفع حسب المنتج' },
  reste: { fr: 'Reste', ar: 'المتبقي' },

  // === REMBOURSEMENTS ===
  nouvelle_demande: { fr: 'Nouvelle Demande', ar: 'طلب جديد' },
  demande_remboursement: { fr: 'Demande de Remboursement', ar: 'طلب استرداد' },
  raison: { fr: 'Raison', ar: 'السبب' },
  en_attente: { fr: 'En Attente', ar: 'في الانتظار' },
  approuve: { fr: 'Approuve', ar: 'موافق عليه' },
  refuse: { fr: 'Refuse', ar: 'مرفوض' },
  approuver: { fr: 'Approuver', ar: 'موافقة' },
  refuser: { fr: 'Refuser', ar: 'رفض' },
  autorise_par: { fr: 'Autorise par', ar: 'مصرح من' },

  // === AVOIRS ===
  credit_client: { fr: 'Credit Client', ar: 'رصيد دائن للعميل' },
  reglement_avoir: { fr: 'Reglement Avoir', ar: 'تسوية الرصيد' },
  avoir_regle: { fr: 'Regle', ar: 'مسوّى' },
  avoir_en_attente: { fr: 'En attente de reglement', ar: 'في انتظار التسوية' },

  // === RAPPORTS ===
  chiffre_affaires: { fr: "Chiffre d'Affaires", ar: 'رقم الأعمال' },
  encaissements: { fr: 'Encaissements', ar: 'التحصيلات' },
  impayes: { fr: 'Impayes', ar: 'غير مدفوع' },
  top_produits: { fr: 'Top Produits', ar: 'أفضل المنتجات' },
  top_clients: { fr: 'Top Clients', ar: 'أفضل العملاء' },
  commissions_tab: { fr: 'Commissions', ar: 'العمولات' },
  performance_agents: { fr: 'Performance Agents', ar: 'أداء الوكلاء' },
  historique_client: { fr: 'Historique Client', ar: 'سجل العميل' },
  exporter_excel: { fr: 'Exporter Excel', ar: 'تصدير Excel' },
  telecharger: { fr: 'Telecharger', ar: 'تحميل' },
  telecharger_pdf: { fr: 'Telecharger PDF', ar: 'تحميل PDF' },
  date_debut: { fr: 'Date Debut', ar: 'تاريخ البداية' },
  date_fin: { fr: 'Date Fin', ar: 'تاريخ النهاية' },
  nb_ventes: { fr: 'Nb Ventes', ar: 'عدد المبيعات' },
  total_paye_label: { fr: 'Total Paye', ar: 'إجمالي المدفوع' },
  total_restant_label: { fr: 'Total Restant', ar: 'إجمالي المتبقي' },

  // === DASHBOARD ===
  total_ventes: { fr: 'Total Ventes', ar: 'إجمالي المبيعات' },
  total_clients: { fr: 'Total Clients', ar: 'إجمالي العملاء' },
  revenue: { fr: 'Revenue', ar: 'الإيرادات' },
  ce_mois: { fr: 'Ce mois', ar: 'هذا الشهر' },
  ventes_recentes: { fr: 'Ventes Recentes', ar: 'المبيعات الأخيرة' },
  devis_en_attente: { fr: 'devis en attente de validation', ar: 'عروض أسعار في انتظار التأكيد' },
  voir_devis: { fr: 'Voir les devis', ar: 'عرض عروض الأسعار' },
  ventes_impayees: { fr: 'ventes impayees', ar: 'مبيعات غير مدفوعة' },
  voir_impayes: { fr: 'Voir les impayes', ar: 'عرض غير المدفوع' },

  // === VOYAGES ===
  nouveau_voyage: { fr: 'Nouveau Voyage', ar: 'رحلة جديدة' },
  modele_excel: { fr: 'Modele Excel', ar: 'نموذج Excel' },
  importer_excel: { fr: 'Importer Excel', ar: 'استيراد Excel' },
  date_depart: { fr: 'Date Depart', ar: 'تاريخ المغادرة' },
  date_retour: { fr: 'Date Retour', ar: 'تاريخ العودة' },
  transport: { fr: 'Transport', ar: 'وسيلة النقل' },
  prix_double: { fr: 'Prix Ch.Double', ar: 'سعر غرفة مزدوجة' },
  prix_triple: { fr: 'Prix Ch.Triple', ar: 'سعر غرفة ثلاثية' },
  prix_single: { fr: 'Single', ar: 'فردي' },
  places_vendues: { fr: 'Places Vendues', ar: 'الأماكن المباعة' },

  // === BILLETTERIE ===
  factures_quinzaine: { fr: 'Factures par Quinzaine', ar: 'فواتير نصف شهرية' },
  quinzaine: { fr: 'Quinzaine', ar: 'نصف الشهر' },
  net_a_payer: { fr: 'Net a Payer', ar: 'الصافي المستحق' },

  // === CHAT ===
  chat_equipe: { fr: 'Chat Equipe', ar: 'محادثة الفريق' },
  notifications: { fr: 'Notifications', ar: 'الإشعارات' },
  chat_general: { fr: 'Chat General', ar: 'محادثة عامة' },
  votre_message: { fr: 'Votre message...', ar: '...رسالتك' },
  tout_marquer_lu: { fr: 'Tout marquer comme lu', ar: 'تعيين الكل كمقروء' },
  non_lues: { fr: 'non lues', ar: 'غير مقروءة' },
  aucun_message: { fr: 'Aucun message', ar: 'لا توجد رسائل' },
  aucune_notification: { fr: 'Aucune notification', ar: 'لا توجد إشعارات' },
  nouveau_message: { fr: 'Vous avez un nouveau message', ar: 'لديك رسالة جديدة' },

  // === AGENTS ===
  nouvel_agent: { fr: 'Nouvel Agent', ar: 'وكيل جديد' },
  autorisations: { fr: 'Autorisations', ar: 'الصلاحيات' },
  mot_de_passe: { fr: 'Mot de passe', ar: 'كلمة المرور' },
  reinitialiser: { fr: 'Reinitialiser', ar: 'إعادة تعيين' },

  // === PARAMETRES ===
  parametres_agence: { fr: 'Parametres Agence', ar: 'إعدادات الوكالة' },
  nom_agence: { fr: 'Nom Agence', ar: 'اسم الوكالة' },
  logo: { fr: 'Logo', ar: 'الشعار' },
  infos_legales: { fr: 'Informations Legales', ar: 'المعلومات القانونية' },
  agrement: { fr: 'Agrement', ar: 'الاعتماد' },
  historique_ventes: { fr: 'Historique des Ventes', ar: 'سجل المبيعات' },
  email_historique_note: { fr: 'Vous allez recevoir l\'historique de la journee dans cet email chaque jour a 19h', ar: 'ستتلقى سجل اليوم على هذا البريد كل يوم الساعة 19:00' },

  // === PDF / RECU ===
  recu_vente: { fr: 'Recu de Vente', ar: 'إيصال البيع' },
  recu_paiement: { fr: 'Recu de Paiement', ar: 'إيصال الدفع' },
  recu_remboursement: { fr: 'Recu de Remboursement', ar: 'إيصال الاسترداد' },

  // === HISTORIQUE EMAILS ===
  historique_emails: { fr: 'Historique Emails', ar: 'سجل البريد الإلكتروني' },
  destinataire: { fr: 'Destinataire', ar: 'المرسل إليه' },
  envoye: { fr: 'Envoye', ar: 'مُرسَل' },
  echec: { fr: 'Echec', ar: 'فشل' },

  // === LOGIN ===
  connexion: { fr: 'Connexion', ar: 'تسجيل الدخول' },
  verification: { fr: 'Verification', ar: 'التحقق' },
  code_otp: { fr: 'Code de verification', ar: 'رمز التحقق' },
  envoyer_code: { fr: 'Envoyer le code', ar: 'إرسال الرمز' },
};

export default translations;
